// 设置 login
export const SET_ROUTE_INFO = 'set_route_info';

// 设置 wpsUrl
export const SET_WPS_URL = 'set_wps_url';

// 设置全局状态
export const SET_GLOBAL_STATUS = 'set_global_status';

// 设置全局信息提示
export const SET_ERROR_MESSAGE = 'set_error_message';

// 设置系统权限
export const SET_SYSTEM_PERM = 'set_system_perm'

// 设置wps 记录日志的 data
export const SET_OPERATION_ID = 'set_operation_Id'

//设置当前用户加入得组织列表数据
export const SET_ORG_LIST = 'set_org_list'


// WEBPACK FOOTER //
// ./src/store/mutationTypes.js